let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("3WmO0")).then(() => parcelRequire('c70Lr'));